/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AddUpdateRunModal_defaultMachine$ref: FragmentReference;
declare export opaque type AddUpdateRunModal_defaultMachine$fragmentType: AddUpdateRunModal_defaultMachine$ref;
export type AddUpdateRunModal_defaultMachine = {|
  +id: string,
  +type: {|
    +id: string
  |},
  +$refType: AddUpdateRunModal_defaultMachine$ref,
|};
export type AddUpdateRunModal_defaultMachine$data = AddUpdateRunModal_defaultMachine;
export type AddUpdateRunModal_defaultMachine$key = {
  +$data?: AddUpdateRunModal_defaultMachine$data,
  +$fragmentRefs: AddUpdateRunModal_defaultMachine$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "AddUpdateRunModal_defaultMachine",
  "type": "Machine",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "type",
      "storageKey": null,
      "args": null,
      "concreteType": "MachineType",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '5a74bc22a6ca93905dc3e65a253be350';
module.exports = node;
